import React from "react";
import { Card, CardContent, CardTitle } from "../ui/card";
import { IoFastFoodSharp } from "react-icons/io5";
import { PiCheers } from "react-icons/pi";

export const About = () => {
  return (
    <div
      id="about"
      className="mb-10 w-full py-5 sm:py-10 xl:py-20 px-10 min-h-screen bg-white flex flex-col items-center justify-center gap-10"
    >
      <div className="">
        <h1 className="font-extrabold font-Lato text-subtle text-[40px] lg:text-[50px] xl:text-[60px] text-center mb-5 xl:mb-10">
          Sobre Nosotros
        </h1>
      </div>
      <div
        id="cards-container"
        className="w-full h-full max-w-[1400px] flex flex-wrap items-center justify-center gap-10"
      >
        <Card className="xl:min-h-[400px] md:min-h-[300px] min-h-[250px] sm:line-clamp-none sm:max-w-[400px] basis-1/1 md:basis-1/2 lg:basis-1/3 border flex flex-col items-center py-5 px-2 gap-4 hover:outline hover:outline-2 hover:outline-mariposa group flex-grow">
          <CardTitle className="flex flex-col items-center gap-4 font-Lato text-subtle text-[24px] mb-4 ">
            <img
              src="/images/Icons/open-book-svgrepo-com.svg"
              alt=""
              className={`text-mariposa h-[40px] `}
            />
            Nuestra Historia
          </CardTitle>
          <CardContent className="h-full">
            <p className="text-center text-xl font-Roboto text-subtle  text-justify line-clamp-[15]">
              Desde nuestros inicios, en{" "}
              <span className="text-mariposa text-xl font-semibold font-Dancing">
                La Mariposa
              </span>{" "}
              nos hemos dedicado a ofrecer una experiencia única, fusionando
              recetas tradicionales e innovadoras para crear un ambiente cálido
              y familiar.
            </p>
          </CardContent>
        </Card>

        <Card className="xl:min-h-[400px] md:min-h-[300px] min-h-[250px] sm:line-clamp-none sm:max-w-[400px] basis-1/1 md:basis-1/2 lg:basis-1/3 border flex flex-col items-center py-5 px-2 gap-4 hover:outline hover:outline-2 hover:outline-mariposa group">
          <CardTitle className="flex flex-col items-center gap-4 font-Lato text-subtle text-[24px] mb-4 ">
            <IoFastFoodSharp className="text-mariposa text-[40px]" />
            Calidad
          </CardTitle>
          <CardContent className="place-self-center">
            <p className="text-center text-xl font-Roboto text-subtle  text-justify line-clamp-[15]">
              Priorizamos la frescura y calidad en cada platillo, seleccionando
              ingredientes de proveedores locales para ofrecer una experiencia
              auténtica y deliciosa.
            </p>
          </CardContent>
        </Card>

        <Card className="xl:min-h-[400px] md:min-h-[300px] min-h-[250px] sm:line-clamp-none sm:max-w-[400px] basis-1/1 md:basis-1/2 lg:basis-1/3 border flex flex-col items-center py-5 px-2 gap-4 hover:outline hover:outline-2 hover:outline-mariposa group">
          <CardTitle className="flex flex-col items-center gap-4 font-Lato text-subtle text-[24px] mb-4 ">
            <PiCheers className="text-mariposa text-[40px]" />
            Un Espacio para Compartir
          </CardTitle>
          <CardContent className="place-self-center">
            <p className="text-center text-xl font-Roboto text-subtle  text-justify line-clamp-[15]">
              <span className="text-mariposa text-xl font-Dancing ml-1">
                La Mariposa
              </span>{" "}
              es el lugar ideal para disfrutar con familia, amigos o en pareja,
              ofreciendo un ambiente acogedor para crear momentos inolvidables.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
